import { render, staticRenderFns } from "./FinalReviewStatus.vue?vue&type=template&id=692c7353&scoped=true"
import script from "./FinalReviewStatus.vue?vue&type=script&lang=js"
export * from "./FinalReviewStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c7353",
  null
  
)

export default component.exports